Librarian.Modules.Chart = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["renderChart"],

    options: {
        classPrefix: "modules-chart-",
        chartName: null,
        chartConfig: null,
        data: null, 
        postData: null, 
        monthDateRange: null, 
        id: null, 
    },

    chart: null,

    initialize: function (options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function () {
        if (!this.wrapperEl)
            return;

        this.parent();

        if(this.options.monthDateRange) {
            var rightNow = new Date();
            var startTime = new Date();
            startTime.setMonth(startTime.getMonth() - this.options.monthDateRange);

            var edate = String(("0" + (rightNow.getMonth() + 1)).slice(-2)) + "-" + String(("0" + rightNow.getDate()).slice(-2)) + "-" + String(rightNow.getFullYear());
            var sdate = String(("0" + (startTime.getMonth() + 1)).slice(-2)) + "-" + String(("0" + startTime.getDate()).slice(-2)) + "-" + String(startTime.getFullYear());
        }

        // Create chart element
        this.chartEl = new Element("div", { id: "chart_module_" + String.uniqueID(), width: "80%" });

        this.containerEl.grab(this.chartEl);

        // Generate the URL
        var url = Librarian.path.getMethodUrl("getcrep") + "&out=chart&name=" + this.options.chartName + "&sdate=" + sdate + "&edate=" + edate;
        if (typeof this.options.data == "object") {
            for (var key in this.options.data) {
                if (!this.options.data.hasOwnProperty(key))
                    continue;

                url += '&' + key + '=' + encodeURIComponent(this.options.data[key]);
            }
        }

        if(this.options.postData) {

            new Librarian.Request.JSON({
                url: url,
                onSuccess: function(json) {
                    this.renderChart(json);
                }.bind(this)
            }).post(this.options.postData);
        
        } 
        else {

            new Librarian.Request.JSON({
                url: url,
                onSuccess: function(json) {
                    this.renderChart(json);
                }.bind(this)
            }).send();
        }
        
    },

    renderChart: function(data) {
        var srs = data.series,
            labels = data.labels,
            cfg;

        if (!srs || !labels || (srs.length == 0) || (labels.length == 0))
            return;

        if(this.options.chartName === "FilePopularity") {
            cfg = Librarian.Modules.Chart.FilePopularityConfig;
        } 
        else if(this.options.chartName === "ContentPopularity") {
            cfg = Librarian.Modules.Chart.ContentPopularityConfig;
        }
        else if ((this.options.chartConfig != null) && (typeof this.options.chartConfig == "object"))
            cfg = Object.merge(Librarian.Modules.Chart.defaultConfig, this.options.chartConfig);
        else
            cfg = Librarian.Modules.Chart.defaultConfig;

        // Set up dates
        for (var i = srs.length; i--;) {
            if (srs[i].data !== null) {
                for (var j = srs[i].data.length; j--;) {
                    var pt = srs[i].data[j],
                        split = pt.x.split("-");
                    pt.x = Date.UTC(split[2], split[0] - 1, split[1]);
                }
            }
        }

        cfg.chart.renderTo = this.chartEl;
        cfg.series = srs;
        cfg.yAxis.title = { text: labels[0].label };
        this.chart = new Highcharts.Chart(cfg);
    }
});

Librarian.Modules.Chart.extend({
    defaultConfig: {
        credits: {
            enabled: false
        },
        chart: {
            type: "column",
            marginTop: 0,
            marginLeft: 0,
            marginRight: 0,
            marginBottom: 25,
            spacing: 0,
            height: 200,
            backgroundColor: Browser.ie8 ? "white" : "transparent",
            style: {
                fontFamily: "Lato, sans-serif",
                margin: "0 auto",
                borderBottom: "1px solid #ddd"
            }
        },
        title: {
            x: 0,
            text: "Sends, Downloads & Page Views",
            style: {
                fontFamily: "Lato, sans-serif",
                color: "#222",
            }
        },
        xAxis: {
            type: "datetime",
            style: {
                fontFamily: "Lato, sans-serif",
                padding: "10px"
            },
            lineColor: "transparent",
            lineWidth: 0,
            tickWidth: 0,
            minRange: 24 * 3600 * 1000 * 30,
            minTickInterval: 24 * 3600 * 1000,
            minorGridLineWidth: 0,
            minorTickWidth: 1,
            minorTickLength: 5,
            minorTickInterval: 24 * 3600 * 1000,
            startOnTick: true,
            endOnTick: true,
            labels: {
                overflow: "justify",
                formatter: function() {
                    return Highcharts.dateFormat("%b", this.value);
                },
                style: {
                    color: "#a0a0a0",
                    textTransform: "uppercase"
                }
            }
        },
        yAxis: {
            allowDecimals: false,
            min: 0,
            gridLineColor: "#ddd",
            style: {
                fontFamily: "Lato, sans-serif"
            },
            labels: {
                enabled: true
            }
        },
        tooltip: {
            useHTML: true,
            formatter: function() {
                return this.y;
            },
            style: {
                fontFamily: "Lato, sans-serif",
                color: "#909090"
            }
        },
        legend: {
            enabled: true,
            title: {
                text: "File Shares"
            },
            x: -150, 
            y: -150,
        }
    },

    FilePopularityConfig: {
        colors: ["#1b75bc", "#00aeef", "#a6ce39"],
        credits: {
            enabled: false
        },
        chart: {
            type: "column",
            marginTop: 75,
            marginLeft: 60,
            marginRight: 25,
            marginBottom: 75,
            height: 325,
            width: 625,
            backgroundColor: Browser.ie8 ? "white" : "transparent"
        },
        title: {
            text: "Sends, Downloads & Page Views",
            align: "left", 
            x: 10, 
            y: 25
        },
        xAxis: {
            type: "datetime",
            lineWidth: 0,
            tickWidth: 0,
            minRange: 24 * 3600 * 1000 * 30,
            minTickInterval: 24 * 3600 * 1000,
            minorGridLineWidth: 0,
            minorTickWidth: 1,
            minorTickLength: 5,
            minorTickInterval: 24 * 3600 * 1000,
            startOnTick: true,
            endOnTick: true,
            labels: {
                formatter: function() {
                    return Highcharts.dateFormat("%b", this.value);
                }
            }
        },
        yAxis: {
            allowDecimals: false,
            min: 0,
            gridLineColor: "#ddd",
            tickAmount: 6,
            startOnTick: true,
            endOnTick: true,
            labels: {
                enabled: true
            }
        },
        tooltip: {
            useHTML: true,
            formatter: function() {
                return this.y;
            }
        },
        legend: {
            itemDistance: 8, 
            symbolRadius: 0, 
            x: 195, 
            itemStyle: {
                color: "#a0a0a0"
            }
        }
    },

    ContentPopularityConfig: {
        colors: ["#a6ce39"],
        credits: {
            enabled: false
        },
        chart: {
            type: "column",
            marginTop: 50,
            marginLeft: 45,
            marginRight: 0,
            marginBottom: 75,
            height: 325,
            backgroundColor: Browser.ie8 ? "white" : "transparent"
        },
        title: {
            x: -10,
            text: "Content Views",
            align: "left",
            style: {
                fontFamily: "Lato, sans-serif",
            }
        },
        xAxis: {
            type: "datetime",
            lineWidth: 0,
            tickWidth: 0,
            minRange: 24 * 3600 * 1000 * 30,
            minTickInterval: 24 * 3600 * 1000,
            minorGridLineWidth: 0,
            minorTickWidth: 1,
            minorTickLength: 5,
            minorTickInterval: 24 * 3600 * 1000,
            startOnTick: true,
            endOnTick: true,
            labels: {
                overflow: "justify",
                formatter: function() {
                    return Highcharts.dateFormat("%b", this.value);
                }
            }, 
            itemStyle: {
                color: "#000000"
            }
        },
        yAxis: {
            allowDecimals: false,
            min: 0,
            gridLineColor: "#ddd",
            style: {
                fontFamily: "Lato, sans-serif"
            },
            labels: {
                enabled: true
            }
        },
        tooltip: {
            useHTML: true,
            formatter: function() {
                return this.y;
            },
            style: {
                fontFamily: "Lato, sans-serif",
                color: "#909090"
            }
        },
        legend: {
            enabled: false
        } 
    }
});